import React, { useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const scaleIn = keyframes`
  from { opacity: 0; transform: scale(0.85); }
  to { opacity: 1; transform: scale(1); }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(3,4,94,0.85);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1rem;
  animation: ${fadeIn} 0.4s ease;
`;

const Box = styled.div`
  background: white;
  border-radius: 24px;
  overflow: hidden;
  max-width: 560px;
  width: 100%;
  box-shadow: 0 30px 80px rgba(3,4,94,0.4);
  animation: ${scaleIn} 0.4s ease;
`;

const Banner = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const Footer = styled.div`
  padding: 1.8rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #03045e, #023e8a);

  p {
    color: rgba(255,255,255,0.7);
    font-size: 0.9rem;
  }
`;

const NextBtn = styled.button`
  padding: 12px 32px;
  background: linear-gradient(135deg, #00b4d8, #0077b6);
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(0,180,216,0.4);
  font-family: 'Inter', sans-serif;
  letter-spacing: 0.5px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(0,180,216,0.6);
  }
`;

export default function WelcomePopup({ onClose }) {
  const audioRef = useRef(null);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.play().catch(() => {});
    }
  }, []);

  return (
    <Overlay>
      <Box>
        <Banner src="/banner.jpeg" alt="Welcome to Hidrogen.id" />
        <audio ref={audioRef} loop>
          <source src="/assets/media/testiAudio1.m4a" type="audio/mp4" />
        </audio>
        <Footer>
          <p>Selamat datang di Hidrogen.id</p>
          <NextBtn onClick={onClose}>Masuk →</NextBtn>
        </Footer>
      </Box>
    </Overlay>
  );
}
